import React from 'react';
import {
  Link,
  RaRecord,
  TextField,
  TextFieldProps,
  useCreatePath,
  useRecordContext,
  useResourceContext,
} from 'react-admin';
import { get } from 'lodash';
import { useScopedEmbeddedViewContext } from '../utils/ScopedEmbeddedViewContext';

const LinkField = <RecordType extends RaRecord>({
  sx,
  link,
  linkType,
  ...props
}: TextFieldProps<RecordType> & {
  link?: string;
  linkType?: string;
}) => {
  const createPath = useCreatePath();

  const resource = useResourceContext();
  const record = useRecordContext();
  const finalLink = link ?? createPath({ resource, id: get(record, props.source), type: linkType ?? 'edit' });

  const scope = useScopedEmbeddedViewContext();
  const shouldLink = !scope.isScopedEmbedded
    || (scope.scopedResource === resource && scope.scopedRecordId === record?.id);

  return shouldLink ? (
    <Link to={finalLink}>
      <TextField
        sx={sx}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </Link>
  ) : (
    <TextField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

export default LinkField;
